import { render, staticRenderFns } from "./footer-view.vue?vue&type=template&id=29b40d98&scoped=true&"
import script from "./footer-view.vue?vue&type=script&lang=js&"
export * from "./footer-view.vue?vue&type=script&lang=js&"
import style0 from "./footer-view.vue?vue&type=style&index=0&id=29b40d98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b40d98",
  null
  
)

export default component.exports